import { render, staticRenderFns } from "./navItem.vue?vue&type=template&id=75546180&scoped=true&"
import script from "./navItem.vue?vue&type=script&lang=js&"
export * from "./navItem.vue?vue&type=script&lang=js&"
import style0 from "./navItem.vue?vue&type=style&index=0&id=75546180&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75546180",
  null
  
)

export default component.exports